<div class="wrapper" *ngIf="loaded">
  <span class="text" [innerHtml]="support.headline"></span>
  <img [src]="support.image" />
  <span class="text" [innerHtml]="support.underline"></span>
  <span class="text" [innerHtml]="support.text"></span>
  <div class="info-wrapper" *ngIf="support.phoneTitle">
    <div class="icon">
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21.677 16.662c-1.332 0-2.621-.217-3.824-.607a1.059 1.059 0 0 0-1.094.26l-1.7 2.134c-3.066-1.462-5.937-4.225-7.465-7.399l2.113-1.798c.292-.304.379-.726.26-1.105a12.082 12.082 0 0 1-.607-3.825c0-.585-.487-1.072-1.072-1.072H4.538c-.585 0-1.289.26-1.289 1.072 0 10.065 8.374 18.428 18.427 18.428.77 0 1.073-.683 1.073-1.278v-3.738c0-.585-.488-1.072-1.073-1.072z"
          fill="#577399"
        />
      </svg>
    </div>
    <div class="text-wrapper">
      <span class="title" [innerHtml]="support.phoneTitle"></span>
      <a style="text-decoration: none;" [href]="'tel:' + support.phoneText">
        <span class="info" [innerHtml]="support.phoneText"></span>
      </a>
    </div>
  </div>
  <div class="info-wrapper" *ngIf="support.mailTitle">
    <div class="icon">
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21.666 4.333H4.334A2.164 2.164 0 0 0 2.177 6.5l-.01 13c0 1.191.975 2.166 2.166 2.166h17.334a2.173 2.173 0 0 0 2.166-2.166v-13a2.173 2.173 0 0 0-2.166-2.167zm0 4.333L13 14.083 4.333 8.666V6.5L13 11.916 21.666 6.5v2.166z"
          fill="#577399"
        />
      </svg>
    </div>
    <div class="text-wrapper">
      <span class="title" [innerHtml]="support.mailTitle"></span>
      <a style="text-decoration: none;" [href]="'mailto:' + support.mailText">
        <span class="info" [innerHtml]="support.mailText"></span>
      </a>
    </div>
  </div>
  <div class="info-wrapper" *ngIf="support.custom">
    <div class="icon">
      <img [src]="support.customIcon" />
    </div>
    <div class="text-wrapper">
      <span class="title" [innerHtml]="support.customTitle"></span>
      <span class="info" [innerHtml]="support.customText"></span>
    </div>
  </div>
</div>
